/**
 * Wishlist persistence (localStorage) + normalized events on document & window.
 */
(function () {
  'use strict';

  const WISHLIST_KEY = 'wishlist';

  function normalizeProductId(productId) {
    return String(productId == null ? '' : productId).trim();
  }

  function normalizeList(ids) {
    return [...new Set((ids || []).map(normalizeProductId).filter(Boolean))];
  }

  function getWishlist() {
    try {
      const raw = localStorage.getItem(WISHLIST_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      return normalizeList(parsed);
    } catch {
      return [];
    }
  }

  function emitUpdated(wishlist, meta) {
    const detail = Object.assign({ wishlist, ids: wishlist }, meta || {});
    try {
      document.dispatchEvent(new CustomEvent('wishlist:updated', { detail }));
    } catch {
      /* ignore */
    }
    try {
      window.dispatchEvent(new CustomEvent('wishlist:updated', { detail }));
    } catch {
      /* ignore */
    }
  }

  function saveWishlist(ids, meta) {
    const unique = normalizeList(ids);
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(unique));
    emitUpdated(unique, meta);
    return unique;
  }

  function isInWishlist(productId) {
    const id = normalizeProductId(productId);
    if (!id) return false;
    return getWishlist().includes(id);
  }

  function toggleWishlist(productId) {
    const id = normalizeProductId(productId);
    if (!id) return getWishlist();
    const list = getWishlist();
    const idx = list.indexOf(id);
    if (idx === -1) {
      list.push(id);
    } else {
      list.splice(idx, 1);
    }
    return saveWishlist(list);
  }

  function removeFromWishlist(productId) {
    const id = normalizeProductId(productId);
    if (!id) return getWishlist();
    const list = getWishlist().filter((x) => x !== id);
    return saveWishlist(list);
  }

  function mergeWithLocal(serverIds) {
    let srv = serverIds;
    if (typeof srv === 'string') {
      try {
        srv = JSON.parse(srv);
      } catch {
        srv = [];
      }
    }
    if (!Array.isArray(srv)) srv = [];
    const normalized = normalizeList(srv);
    const local = getWishlist();
    return normalizeList([...normalized, ...local]);
  }

  function listsEqual(a, b) {
    if (a.length !== b.length) return false;
    const sa = [...a].sort();
    const sb = [...b].sort();
    return sa.every((v, i) => v === sb[i]);
  }

  window.WishlistStorage = {
    WISHLIST_KEY,
    normalizeProductId,
    getWishlist,
    saveWishlist,
    isInWishlist,
    toggleWishlist,
    removeFromWishlist,
    mergeWithLocal,
    listsEqual,
    emitUpdated,
  };
})();
